const arrowIcon = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="&#229;&#177;&#149;&#229;&#188;&#128;">
<path id="Vector" d="M9.21602 13.4568C9.50977 13.7576 9.98477 13.7576 10.2754 13.4568L16.2785 7.31346C16.5723 7.0127 16.5723 6.52635 16.2785 6.22878C15.9848 5.93121 15.5098 5.92801 15.2191 6.22878L9.75039 11.8282L4.27852 6.22558C3.98477 5.92481 3.50977 5.92481 3.21914 6.22558C2.92852 6.52635 2.92539 7.01269 3.21914 7.31026L9.21602 13.4568Z" fill="#313638"/>
</g>
</svg>
`;

class AccordionElement extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.render();
  }

  connectedCallback() {
    const header = this.shadowRoot.querySelector(".accordion-header");
    header.addEventListener("click", () => this.toggle());

    document.addEventListener("DOMContentLoaded", () => {
      console.log(this.querySelectorAll(".content-item")?.length < 2);
      if (this.querySelectorAll(".content-item")?.length < 2) {
        if (this.querySelector(".content-grid")) {
          this.querySelector(".content-grid").style.gridTemplateRows = "1fr";
        }
      }
    });
  }

  toggle() {
    console.log('toggle')
    const content = this.shadowRoot.querySelector(".accordion-content");
    const icon = this.shadowRoot.querySelector("svg");
    const isOpen = this.hasAttribute("open");

    if (isOpen) {
      this.removeAttribute("open");
      requestAnimationFrame(() => {
        content.style.maxHeight = null;
        icon.style.transform = "rotate(0deg)";
      });
    } else {
      this.setAttribute("open", "");
      requestAnimationFrame(() => {
        content.style.maxHeight = `${content.scrollHeight*5}px`;
        icon.style.transform = "rotate(180deg)";
      });
    }
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>
       :host {
          display: block;
          border-top: 1px solid #D9D9D9;
          border-bottom: none; 
          overflow: hidden;
        }

        :host(:last-of-type) {
          border-bottom: 1px solid #D9D9D9; 
        }

        .accordion-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 18px 0px;
          color: #313638;
          font-size: 22px;
          font-style: normal;
          font-weight: 500;
          line-height: 30px; 
          cursor: pointer;
          font-family: var(--font-heading-family);
        }

        .accordion-content {
          overflow: hidden;
          display: none;
          max-height: 0;
          transition: max-height 0.3s ease-out;
          background-color: #fff;
          font-family: var(--font-body-family);
        }

        :host([open]) {
          border-bottom: 0;
        }

        :host([open]) .accordion-content {
          display: block;
          max-height: 1000px;
          text-align: left;
        }

      </style>
      <div class="accordion-header">
        <slot name="heading">Default Heading</slot>
        ${arrowIcon}
      </div>
      <div class="accordion-content">
        <slot name="content">Default Content</slot>
      </div>
    `;
  }
}

customElements.define("accordion-element", AccordionElement);
